import type { ICellRendererParams } from "ag-grid-community";

import type { ConstructorRoad } from "../constructor-roads-page.lib";

/** Ячейка «Входной контроль»: исполнитель, приглушённый, если не настроен. */
export const RoadIntakeCell = (params: ICellRendererParams<ConstructorRoad>) => {
  const road = params.data;

  if (!road) {
    return null;
  }

  return road.intakeIsConfigured ? road.intakeLabel : <span className="text-type-light">{road.intakeLabel}</span>;
};
